import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { toJS } from 'mobx';

export default function cloneEvent(calendarEvent: CalendarEvent): CalendarEvent {
    let clone: CalendarEvent = deepCloneObject(calendarEvent);

    [
        'Attachments',
        'Locations',
        'Categories',
        'RequiredAttendees',
        'OptionalAttendees',
        'Resources',
        'InboxReminders',
    ].map(key => {
        // For existing event, toJS strips any observables from the item, making sure any fullItemsCache changes that might occur while we are editing cannot modify our baseline.
        // For new event, this is equivalent to converting undefined/null to an empty array.
        clone[key] = clone[key] ? toJS(calendarEvent[key]) : [];
    });

    return clone;
}

function deepCloneObject(obj) {
    if (!obj) {
        return obj;
    }

    // Shallow copy the object first so that all required fields are cloned to prevent the compile error.
    const clone = { ...obj };
    const keys = Object.keys(obj);
    keys.forEach(key => {
        if (!obj[key] && typeof obj[key] == 'object') {
            clone[key] = deepCloneObject(obj[key]);
        } else {
            clone[key] = obj[key];
        }
    });

    return clone;
}
